// import React from 'react'

const Loan_Id=()=>{
    return (
  <>
  <input type="text" placeholder="Loan Id " className="Loan_Id_Input"></input> <br/>
  <p className="Instruction">Enter your 12-digit unique Loan Id</p>
  <button className="Loan_Id_OTP">GET OTP</button>
  </>
    )    
  
  }
  
  export default Loan_Id;